export const NotFound = () => {
  return <p>Sorry, we couldn't find that page :(</p>;
};
